// @ts-nocheck
import { SubSection, FieldLabel, inputClass } from "./SectionWrapper";
import { EventData } from "@/types/events";
import { CoachAttendanceSection } from "./CoachAttendanceSection";
import { MediaCredentialsSection } from "./MediaCredentialsSection";
import { ShortDescriptionField } from "./ShortDescriptionField";

interface Props {
  event: EventData;
  updateEvent: (updates: Partial<EventData>) => void;
  eventId: string | undefined;
}

export function CoachesMediaSection({ event, updateEvent, eventId }: Props) {
  const mediaEnabled = !!(event as any).media_credentials_enabled;
  const coachEnabled = !!(event as any).coach_attendance_enabled;

  return (
    <div className="space-y-8">
      {/* Media Credentials settings */}
      <SubSection title="Media Credentials">


        {/* Media Credentials form builder + applications (contains the canonical Enable toggle) */}
        {eventId && (
          <MediaCredentialsSection event={event} updateEvent={updateEvent} eventId={eventId} />
        )}

        {mediaEnabled && (
          <div className="space-y-3 pl-4 border-l-2 border-primary/20 mt-3">
            <div>
              <FieldLabel>Notification Email</FieldLabel>
              <input
                type="email"
                value={event.media_credentials_notification_email || ""}
                onChange={(e) => updateEvent({ media_credentials_notification_email: e.target.value })}
                className={inputClass}
              />
            </div>
          </div>
        )}
      </SubSection>

      <div className="border-t border-border" />

      {/* College Coaches settings */}
      <SubSection title="College Coaches">
        <label className="flex items-start justify-between gap-3 p-3 border border-border rounded-lg">
          <div>
            <div className="text-sm font-medium">Show attending coaches on public event page</div>
            <div className="text-xs text-muted-foreground mt-1">
              When checked, the public event page displays a College Coaches Attending section with logos and details.
            </div>
          </div>
          <input
            type="checkbox"
            checked={(event as any).show_coaches_publicly !== false}
            onChange={(e) => updateEvent({ show_coaches_publicly: e.target.checked } as any)}
            className="rounded mt-1"
          />
        </label>

        <ShortDescriptionField
          value={(event as any).coaches_short_description}
          onChange={(v) => updateEvent({ coaches_short_description: v } as any)}
        />

        {/* Coach Attendance form builder + roster (contains the canonical Enable toggle) */}
        {eventId && (
          <CoachAttendanceSection event={event} updateEvent={updateEvent} eventId={eventId} />
        )}

        {coachEnabled && (
          <div className="space-y-3 pl-4 border-l-2 border-primary/20 mt-3">
            <div>
              <FieldLabel>External Coaches URL</FieldLabel>
              <input
                type="url"
                value={event.coaches_external_url || ""}
                onChange={(e) => updateEvent({ coaches_external_url: e.target.value })}
                placeholder="https://..."
                className={inputClass}
              />
            </div>
            <div>
              <FieldLabel>Coach Notification Email</FieldLabel>
              <input
                type="email"
                value={event.coach_notification_email || ""}
                onChange={(e) => updateEvent({ coach_notification_email: e.target.value })}
                className={inputClass}
              />
            </div>
          </div>
        )}
      </SubSection>
    </div>
  );
}
